import React from 'react';
import Header from './components/Header';
import Home from './pages/Home';

function App({ user }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Header user={user} />  {/* Pass user to Header */}
      <main className="flex-grow">
        <Home />
      </main>
    </div>
  );
}

export default App;
